module.exports = __webpack_public_path__ + "img/locaL.a0bc00ac.jpg";